import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  NavLink,
} from "react-router-dom";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Inicio from "./layout/Inicio";
import Services from "./layout/Services";
import About from "./layout/About";

//class App extends Component {
function App() {
  return (
    <div className="container">
      <Router>
        <Header></Header>
        <div>
          <Routes>
            <Route exact path="/" element={<Inicio />} />
            <Route exact path="/services" element={<Services />} />
            <Route exact path="/about" element={<About />} />
          </Routes>
        </div>
        <Footer></Footer>
      </Router>
    </div>
  );
}
export default App;
